// extracted by mini-css-extract-plugin
module.exports = {"labelLoanPoints":"styles-module--labelLoanPoints--1PqVC"};